import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import './assets/custom.css'
import Popper from 'popper.js'

import Vue from 'vue'
import App from './App.vue'

import './config/inputmask'
import './config/bootstrap'
import './config/msgs'
import './config/axios'
import './config/mq'
import './config/upload'


import store from './config/store'
import router from './config/router'

import './config/filters'

import vClickOutside from "v-click-outside"
Vue.use(vClickOutside);

// eslint-disable-next-line
import $ from 'jquery'

Vue.config.productionTip = false
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = !(window.devicePixelRatio < 1.5 && /Win/.test(navigator.platform));


// events bus
export const bidbus = new Vue();

// eslint-disable-next-line
var vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
